"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FloatingMenu_1 = require("./FloatingMenu");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return FloatingMenu_1.default; } });
